/**
 * Máscara do documento de uma parte (estipulante/subestipulante).
 *
 * CNPJ e CAEPF têm os MESMOS 14 dígitos, mas máscaras diferentes:
 * - CNPJ  → `00.000.000/0000-00`
 * - CAEPF → `000.000.000/000-00` (CPF do titular + estabelecimento + DV)
 *
 * Por isso o tipo vem de quem chama (`isCaepf`) e não de uma heurística por
 * tamanho. CPF (11 dígitos) é formatado como `000.000.000-00`; qualquer outro
 * tamanho volta como veio, sem inventar máscara.
 */
export function formatPartyDocument(
  value: string | null | undefined,
  options?: { isCaepf?: boolean }
): string {
  const digits = String(value ?? '').replace(/\D/g, '');

  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  if (digits.length === 14) {
    return options?.isCaepf
      ? digits.replace(/(\d{3})(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3/$4-$5')
      : digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  return String(value ?? '');
}
